import { Reveal } from "./Reveal";

export const SectionHeading = ({ eyebrow, title, intro, light = false, className = "" }) => (
  <div className={`max-w-3xl ${className}`}>
    <Reveal y={12}><p className={light ? "text-xs font-bold uppercase tracking-[0.18em] text-[#8FD3CE]" : "eyebrow"}>{eyebrow}</p></Reveal>
    <Reveal delay={0.06}>
      <h2 className={`mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.1] tracking-tight ${light ? "text-white" : "text-[color:var(--navy)]"}`}>{title}</h2>
    </Reveal>
    {intro && (
      <Reveal delay={0.12}>
        <p className={`mt-5 text-base md:text-lg leading-relaxed ${light ? "text-slate-300" : "text-slate-600"}`}>{intro}</p>
      </Reveal>
    )}
  </div>
);
